import { Directive, inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { DASHBOARD_WIDGET } from './dashboard-widget-handle';

/** Marks a widget's header actions: `<ng-template dashboardWidgetActions>…</ng-template>` */
@Directive({
  selector: 'ng-template[dashboardWidgetActions]',
})
export class DashboardWidgetActionsDirective implements OnInit, OnDestroy {
  private readonly handle = inject(DASHBOARD_WIDGET);
  private readonly template = inject(TemplateRef);

  ngOnInit(): void {
    this.handle.setHeaderActions(this.template);
  }

  ngOnDestroy(): void {
    this.handle.setHeaderActions(null);
  }
}
